import { useEffect } from 'react';

import Router from './routes';

import ThemeProvider from './theme';

import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import ThemeColorPresets from './components/ThemeColorPresets';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import GlobalNotification from './containers/layouts/global-notification';

import { dispatch } from './redux/store';
import { getBranding } from './redux/slices/branding';
import useBranding from './hooks/useBranding';

export default function App() {
  const branding = useBranding();

  useEffect(() => {
    dispatch(getBranding());
  }, []);

  // Apply brand identity to the document shell (tab title + favicon).
  useEffect(() => {
    if (branding.name) document.title = branding.name;

    if (branding.favicon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = branding.favicon;
    }
  }, [branding.name, branding.favicon]);

  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <RtlLayout>
          <NotistackProvider>
            <MotionLazyContainer>
              <ProgressBarStyle />
              <ScrollToTop />
              <Router />
              <GlobalNotification />
            </MotionLazyContainer>
          </NotistackProvider>
        </RtlLayout>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}
